<div>
  <form [formGroup]="tenantForm" (ngSubmit)="onSubmit()" autocomplete="off" class="no-scroll">
    <div style="margin-top: 120px;" class="relative mb-3 flex justify-end">
      <button type="button" style="margin-right: 20px; color: var(--text-color); font-family: Noto Sans JP;" (click)="goBack()" class="outline-none h-10">{{ 'cancel' | translate }}</button>
      <button
        *ngIf="!editUserFlag"
        type="submit"
        [disabled]="!tenantForm.valid"
        style="float: right; margin-right: 11.8%; width: 120px"
        class="items-center justify-center text-center button w-40 h-10 rounded text-lg cursor-pointer"
      >
        {{ 'addNewTenant' | translate }}
      </button>
      <button
        *ngIf="editUserFlag"
        type="submit"
        [disabled]="!tenantForm.valid"
        style="float: right; margin-right: 11.8%; width: 270px"
        class="items-center justify-center text-center button w-40 h-10 rounded text-lg cursor-pointer"
      >
        {{ 'addNewTenantandAssign' | translate }}
      </button>
    </div>
    <div style="margin-left: 11.8%; margin-bottom: 8px">
      <span style="font-family: Noto Sans JP; font-weight: bold; color: var(--text-color);">Step 1: </span>
      <span style="font-family: Noto Sans JP; color: var(--text-color);">Complete tenancy setting details</span>
    </div>
    <div class="field-class">
      <span class="field-label">*{{'tenantName'|translate}}</span>
      <input type="text" class="input-field" matInput required id="name" placeholder="Enter Tenant Name" formControlName="name">
      <div *ngIf="tenantForm.get('name')?.invalid && tenantForm.get('name')?.touched" class="error-message">
        <div *ngIf="tenantForm.get('name')?.hasError('required')">This Field is Required</div>
      </div>
    </div>
    <div class="field-class">
      <span class="field-label">{{'expDate'|translate}}</span>
      <p-inputMask mask="9999-99-99" slotChar="yyyy-mm-dd" formControlName="expiration_date" placeholder="Enter Expiration Date" [autoFocus]="false"></p-inputMask>
    </div>
    <div class="field-class">
      <span class="field-label">{{'tenantDescription'|translate}}</span>
      <input type="text" class="input-field" matInput id="description" placeholder="Enter Tenant Description" formControlName="description">
    </div>
    <div style="margin-left: 11.8%; margin-bottom: 8px">
      <span style="font-family: Noto Sans JP; font-weight: bold; color: var(--text-color);">{{'userAccess' | translate}}</span>
      <div *ngFor="let option of roleOptions" style="font-family: Noto Sans JP; margin: 7px 0 5px 0; color: var(--text-color); font-size: 14px; display: flex;">
        <input
          type="checkbox"
          [value]="option.id"
          [checked]="option.alwaysChecked"
          [disabled]="option.alwaysChecked"
          (change)="onRoleSelectionChange($event, option.id)"
          style="margin-right: 6px; margin-top: 2px"
        />
        {{ option.label | translate }}
      </div>
    </div>
    <div style="margin: 15px 0 20px 11.8%">
      <span style="font-family: Noto Sans JP; font-weight: bold; color: var(--text-color);">Step 2: </span>
      <span style="font-family: Noto Sans JP; color: var(--text-color);">Add or edit companies</span>
    </div>
    <button
      type="button"
      class="button h-10 rounded"
      style="margin-left: 11.8%; width: 140px;"
      (click)="addCompany()"
    >
      + {{"addCompany" | translate}}
    </button>
  </form>
  <div *ngFor="let company of getSelectedCompanies()" class="company-section">
    <div class="company-header">
      <span>{{ company.name }}</span>
      <button class="remove-button" (click)="removeCompany(company.id)">×</button>
    </div>
    <div class="vessel-list">
      <div *ngFor="let vessel of vslDict[company.id].vessels" class="vessel-item">
        <span>{{ vessel.name }}</span>
        <button class="remove-button" (click)="removeVessel(company.id, vessel.id)">×</button>
      </div>
    </div>
  </div>
</div>